export default __webpack_public_path__ + "static/tshirt-2-9f2af579c862aa406f9bf2982613a682.jpg";